var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptySun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 24 13 C 30.076 13 35 17.923 35 24 C 35 30.077 30.076 35 24 35 C 17.923 35 13 30.077 13 24 C 13 17.923 17.923 13 24 13 Z M 23.971 15.061 C 19.145 15.061 15.232 19.025 15.232 23.914 C 15.232 28.804 19.145 32.767 23.971 32.767 C 28.797 32.767 32.709 28.804 32.709 23.914 C 32.709 19.025 28.797 15.061 23.971 15.061 Z",
    style: {}
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySun);
export default __webpack_public_path__ + "static/media/empty-sun.39dca45ccca9a67f3be04003ac2cfc48.svg";
export { ForwardRef as ReactComponent };